<template>
  <div :class="cssClass">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      required: false
    }
  },
  computed: {
    cssClass() {
      return {
        'c-badge': true,
        ['c-badge--' + this.variant]: this.variant
      };
    }
  }
};
</script>
